import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Package, Tags, ToggleLeft, Eye } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ products: 0, categories: 0, toggles: 0, hidden: 0 });

    useEffect(() => {
        Promise.all([
            api.get("/admin/products"),
            api.get("/categories"),
            api.get("/admin/toggles"),
        ])
            .then(([prods, cats, togs]) => {
                const products = prods.data || [];
                setStats({
                    products: products.length,
                    categories: (cats.data || []).length,
                    toggles: (togs.data || []).length,
                    hidden: products.filter((p) => p.isHidden).length,
                });
            })
            .catch(() => {});
    }, []);

    const Card = ({ icon: Icon, label, value, to, testId }) => (
        <Link
            to={to}
            className="bg-ivory rounded-2xl p-6 border border-inkDark/5 hover:shadow-lift transition-shadow"
            data-testid={testId}
        >
            <div className="flex items-center justify-between">
                <span className="label-eyebrow">{label}</span>
                <Icon size={18} className="text-skyblueDeep" />
            </div>
            <div className="mt-3 font-display text-4xl text-inkDark">{value}</div>
        </Link>
    );

    return (
        <div data-testid="admin-dashboard">
            <span className="label-eyebrow">Overview</span>
            <h1 className="mt-2 font-display text-4xl text-inkDark">Dashboard</h1>
            <p className="mt-1 text-inkMuted">A quick pulse on the boutique.</p>

            <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-5">
                <Card icon={Package} label="Products" value={stats.products} to="/admin/products" testId="dash-card-products" />
                <Card icon={Tags} label="Categories" value={stats.categories} to="/admin/categories" testId="dash-card-categories" />
                <Card icon={ToggleLeft} label="Feature Toggles" value={stats.toggles} to="/admin/toggles" testId="dash-card-toggles" />
                <Card icon={Eye} label="Hidden Products" value={stats.hidden} to="/admin/products" testId="dash-card-hidden" />
            </div>

            <div className="mt-10 bg-ivory border border-inkDark/5 rounded-2xl p-6 lg:p-8">
                <div className="font-display text-2xl text-inkDark">Quick actions</div>
                <p className="mt-1 text-inkMuted">Curate without friction.</p>
                <div className="mt-6 flex flex-wrap gap-3">
                    <Link to="/admin/products" className="btn-pill text-sm" data-testid="quick-action-products">Add a product</Link>
                    <Link to="/admin/site-settings" className="btn-ghost text-sm">Edit hero &amp; tagline</Link>
                    <Link to="/admin/toggles" className="btn-ghost text-sm">Toggle features</Link>
                </div>
            </div>
        </div>
    );
}
